// Minimum number of items to show accordion toggle button
export const ACCORDION_TOGGLE_MIN_ITEMS = 6;
// Dashboard constants for colors and summary data
export const VIEW_COLORS = {
  default: "#e3f2fd",
  project: "#e8f5e9",
  task: "#fff3e0",
  jobs: "#e0e5ff",
  fullkit: "#c7f9f1",
  materials: "#f7e5ff",
  alerts: "#f7ddec",
  helpneeded: "#efecee",
  rejected: "#f39c12",
  lateApproval: "#9b59b6",
  lateFullkit: "#3498db",
  alertsCount: "#000000",
};

export const SUMMARY_ACCESS_ROLES = ["ProjectManager"];

export const SUMMARY_DATA = [
  {
    count: 0,
    title: "Alerts",
    description: "Open Alerts to be resolved",
    color: VIEW_COLORS.alertsCount,
  },
  {
    count: 0,
    title: "Rejected jobs",
    description: "Jobs pending for rework",
    color: VIEW_COLORS.rejected,
  },
  {
    count: 0,
    title: "Late approvals",
    description: "Approvals to follow-up",
    color: VIEW_COLORS.lateApproval,
  },
  {
    count: 0,
    title: "Late Fullkits",
    description: "CIC & FA pending for fullkit",
    color: VIEW_COLORS.lateFullkit,
  },
];

export const SUCCESS_TOAST_LIFE = 3000;
export const ERROR_TOAST_LIFE = 5000;
export const INFO_TOAST_LIFE = 5000;

// Material Tab

export const hallowGreyCircle = "Fullkit not ready, task start date > today";
export const hallowRedCircle = "Fullkit not ready, task start date =< today";
export const inProgressLate = "In-progress - late";
export const redCross = "Job rejected - until Rework is initiated";
export const greenV = "Job completed";
export const hallowGreenCircle = "Fullkit ready";
export const solidGreenCircle = "In-progress (fullkit was already ready)";
export const NA =
  "Design: No design stage for this FA [or] CIC: CIC Needed = 'CIC Dependent' or 'Not Needed'";

export const UnallocatedHallowGreyCircle = "Stage not started";
export const UnallocatedSolidGreenCircle = "Stage in progress";
export const UnallocatedNA = "Not Applicable";

export const exportExcelColumnNames = [
  "DSBP InitiativeID",
  "DSBP Initiative Name",
  "IL",
  "AWMProjectID",
  "AWMProjectName",
  "PM",
  "Category",
  "RTA ProjectID",
  "RTA Project Name",
  "PIMaterialNumber",
  "PIMaterialID",
  "PIMaterialDescription",
  "PiFPCID",
  "FPCDescription",
  "POA Number",
  "POA Description",
  "B:W",
  "B|W",
  "ETA",
  "AWPrinterDate",
  "Group",
  "Design",
  "CIC",
  "Copy",
  "FA",
  "POA Status",
  "TD State",
  "PMP State",
  "Country Of Sales",
  "Assemble FA Status",
  "FA Approval (A/A/R)",
  "Estimated AW Printer",
];
